/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeCheckbox, BaSeParagraph, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';
import { convertPrimitiveArrayToObject } from '../../../../../utils/arrays';
import { BoxCheckbox, ContentBox } from '../johari-styled';

const cache = Sebrae.StorageUtil.inTemporaryStore();

export const OptionJohari = ({ domain, setQtdSelected }) => {
  const [disabledCheckbox, setDisabledCheckbox] = React.useState(false);

  const conteudosVinculadosIds = [];

  // const convertPrimitiveArrayToObject = (array = [], booleanValue = true) => {
  //   const initialValue = {};
  //   return array.reduce((value, item) => {
  //     return {
  //       ...value,
  //       [item]: booleanValue,
  //     };
  //   }, initialValue);
  // };

  const [conteudosVinculadosObj, setConteudosVinculadosObj] = React.useState(
    convertPrimitiveArrayToObject(conteudosVinculadosIds),
  );

  const onChangeConteudoVinculado = (id, estadoAtual) => {
    setConteudosVinculadosObj((value) => ({
      ...value,
      [id]: !estadoAtual,
    }));
  };

  React.useEffect(() => {
    let arr = [];
    for (const chave in conteudosVinculadosObj) {
      if (conteudosVinculadosObj.hasOwnProperty(chave)) {
        arr.push(conteudosVinculadosObj[chave]);
      }
    }
    const value = arr.filter((e) => e).length === 10 ? true : false;
    setDisabledCheckbox(value);
  }, [conteudosVinculadosObj]);

  React.useEffect(() => {
    const storedState = cache.getItem('@empretec:adjetivos');

    if (storedState) {
      setConteudosVinculadosObj(JSON.parse(storedState));
    } else {
      convertPrimitiveArrayToObject([]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    let quantidadeTrue = 0;

    for (const chave in conteudosVinculadosObj) {
      if (conteudosVinculadosObj[chave] === true) {
        quantidadeTrue++;
      }
    }

    cache.setItem(
      '@empretec:adjetivos',
      JSON.stringify(conteudosVinculadosObj),
    );
    setQtdSelected(quantidadeTrue);
  }, [conteudosVinculadosObj, setQtdSelected]);
  return (
    <ContentBox>
      <BaSeParagraph
        isBold
        color={BaSeTheme.colors.institucionais.cinzaSebrae45}
      >
        {domain.description}:
      </BaSeParagraph>
      <BoxCheckbox>
        {domain.options.map(({ option }) => (
          <div style={{ marginRight: 90 }}>
            <BaSeCheckbox
              key={option.id}
              disabled={!conteudosVinculadosObj[option.id] && disabledCheckbox}
              align="top-left"
              color="default"
              label={option.description}
              onChange={(e) => {
                onChangeConteudoVinculado(
                  option.id,
                  conteudosVinculadosObj[option.id],
                );
              }}
              size="medium"
              checked={conteudosVinculadosObj[option.id]}
            />
          </div>
        ))}
      </BoxCheckbox>
    </ContentBox>
  );
};
